import { render, staticRenderFns } from "./NewsSliderItem.vue?vue&type=template&id=5cf6cf82&lang=pug&"
import script from "./NewsSliderItem.vue?vue&type=script&lang=js&"
export * from "./NewsSliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports